import { defineStore } from 'pinia'

export const useTextStore = defineStore('text', {
    state: () => ({
        isEditing: false,
        editingObjectId: null,
        currentText: '',
        currentFont: 'anzu',
        currentWeight: '',
        currentColor: '#000000',
        currentFontSize: 40,
        currentDirection: 'horizontal',
        // 編集中オブジェクトのロックフラグ (default design 由来)
        lockContent: false,
        lockFont: false,
    }),
    actions: {
        openNew() {
            this.isEditing = false
            this.editingObjectId = null
            this.currentText = ''
            this.lockContent = false
            this.lockFont = false
        },
        openEdit(obj) {
            this.isEditing = true
            this.editingObjectId = obj.id
            this.currentText = obj.content
            this.currentFont = obj.font
            this.currentWeight = obj.weight
            this.currentColor = obj.color
            this.currentFontSize = obj.fontSize
            this.currentDirection = obj.direction ?? 'horizontal'
            this.lockContent = obj.lockContent === true
            this.lockFont    = obj.lockFont    === true
        },
        reset() {
            this.isEditing = false
            this.editingObjectId = null
            this.currentText = ''
            this.lockContent = false
            this.lockFont = false
        },
    },
})
